module.exports = __webpack_public_path__ + "img/monitoring.2350ea9.svg";